import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { OnlineBriefingTemplateConfigModel } from '../../models/online-briefing-option.model';
import { OnlineBriefingBannerStyleEnum } from '../../enums/online-briefing-banner-style.enum';

@Component({
    selector: 'agpr-briefing-canvas-customize',
    templateUrl: './briefing-canvas-customize.component.html',
    styleUrls: ['./briefing-canvas-customize.component.scss'],
    standalone: false
})
export class BriefingCanvasCustomizeComponent {

    readonly bannerStyleEnum = OnlineBriefingBannerStyleEnum;

    @Input() canvasPreview!: OnlineBriefingTemplateConfigModel;
    @Input() id!: string;
    @Output() changes = new EventEmitter<void>();

    constructor(@Inject(APP_BASE_HREF) public appBaseHref: string) {}

    accentColorChanged(color: string): void {
        this.canvasPreview.accentColor = color;
        this.changes.emit();
    }

    bannerStyleChanged(style: OnlineBriefingBannerStyleEnum): void {
        this.canvasPreview.bannerStyle = style;
        this.changes.emit();
    }
}
